const COMING_SOON = [
  { icon: 'ri-shield-line', en: 'Surgical Masks', ar: 'أقنعة جراحية' },
  { icon: 'ri-user-line', en: 'Disposable Coveralls', ar: 'بدلات واقية للاستخدام مرة واحدة' },
  { icon: 'ri-restaurant-line', en: 'Food Wrap & Packaging', ar: 'تغليف الأغذية' },
  { icon: 'ri-cup-line', en: 'Disposable Food Containers', ar: 'أوعية طعام للاستخدام مرة واحدة' },
  { icon: 'ri-knife-line', en: 'Disposable Cutlery', ar: 'أدوات مائدة للاستخدام مرة واحدة' },
  { icon: 'ri-shopping-bag-line', en: 'Food Grade Bags', ar: 'أكياس للاستخدام الغذائي' },
];

export default function ComingSoon() {
  return (
    <section className="section-padding bg-gray-50">
      <div className="container-max">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-2 bg-navy/10 border border-navy/20 text-navy text-sm font-semibold px-5 py-2 rounded-full mb-5">
            🚀 Expanding Our Range
          </span>
          <h2 className="section-title-en text-3xl md:text-4xl mb-2">Coming Soon — More Disposable Products</h2>
          <p className="section-title-ar text-2xl md:text-3xl" dir="rtl">
            قريباً — المزيد من المنتجات الاستهلاكية
          </p>
          <p className="text-gray-600 text-sm mt-3 max-w-xl mx-auto">
            omandisposables.com is expanding beyond gloves — into food grade disposables and medical consumables. Same trusted quality, broader range coming soon.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {COMING_SOON.map((item, i) => (
            <div
              key={i}
              className="relative flex flex-col items-center text-center p-5 bg-white rounded-xl border border-dashed border-gray-300 overflow-hidden"
            >
              <div className="absolute inset-0 bg-white/60 backdrop-blur-[1px] flex items-center justify-center z-10 rounded-xl">
                <span className="bg-navy text-white text-xs font-bold px-2 py-1 rounded-full rotate-[-8deg]">
                  Coming Soon
                </span>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 mb-3">
                <i className={`${item.icon} text-2xl text-gray-400`} />
              </div>
              <p className="font-heading font-semibold text-gray-700 text-xs">{item.en}</p>
              <p className="font-arabic text-gray-600 text-xs mt-0.5" dir="rtl">{item.ar}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
